import { useEffect, useState } from "react";
import { getCheckinPassSecondsRemaining } from "../utils/checkinPass";

/**
 * Tracks a signed check-in pass expiry from wall-clock time. Recomputing from
 * Date.now() prevents timer drift and reseeds when a refreshed pass arrives.
 */
export function useCheckinPassSecondsRemaining(expiresAt: string): number {
  const compute = () => getCheckinPassSecondsRemaining(expiresAt);
  const [remaining, setRemaining] = useState(compute);

  useEffect(() => {
    setRemaining(compute());
    const interval = window.setInterval(() => setRemaining(compute()), 1000);
    return () => window.clearInterval(interval);
  }, [expiresAt]);

  return remaining;
}
